export default __webpack_public_path__ + "static/media/software-image-02.aac55cad.png";